/**
 * 나의 활동 등급
 *
 * 2023-02-10 기준
 *
 * 분석글 점수 + 댓글 점수 + 좋아요 점수 + 오늘의 슨부사 점수 = 등급점수
 *
 * 특정 점수 범위 안에 속하면 해당 등급을 받는다.
 */
export enum ACTIVITY_RANK_TYPE {
  // 등급 없음
  N_RANK,
  D_RANK,
  C_RANK,
  B_RANK,
  A_RANK,
  S_RANK,
}

/**
 * 나의 활동 종류
 */
export enum USER_ACTIVITY_TYPE {
  // 고정배, 프리미엄 분석가 분석글 댓글 작성
  COMPANY_PICK_COMMENT,
  // 고정배, 프리미엄 분석글 좋아요 하기
  COMPANY_PICK_LIKED,
  // 나도승부사 분석글 작성
  USER_PICK_WRITTEN,
  // 오늘의 승부사 선정
  TODAY_USER_PICK,
  // 나도승부사 분석글 댓글, 답글 작성
  USER_PICK_COMMENT,
  // 나도승부사 분석글 좋아요 하기
  USER_PICK_LIKED,
  // 본인의 나도승부사 분석글에 받은 댓글, 답글
  USER_PICK_RECEIVED_COMMENT,
  // 본인의 나도승부사 분석글에 받은 좋아요
  USER_PICK_RECEIVED_LIKE,
  // 실시간 채팅에 베팅내역 공유
  BET_HISTORY_SHARED_TO_CHAT,
  // 나도 승부사 분석글 신고
  REPORT_USER_PICK,
  // 나도 승부사, 회사픽 (고정배, 프리미엄 분석가) 댓글, 답글 신고
  REPORT_USER_COMMENT,
  CHEER_FOR_TEAM,
}
